import { render, staticRenderFns } from "./YouzhicaiProduct.vue?vue&type=template&id=ef21bf3e&scoped=true"
import script from "./YouzhicaiProduct.vue?vue&type=script&lang=js"
export * from "./YouzhicaiProduct.vue?vue&type=script&lang=js"
import style0 from "./YouzhicaiProduct.vue?vue&type=style&index=0&id=ef21bf3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef21bf3e",
  null
  
)

export default component.exports